import React, { useState, useEffect } from "react";
import "./Css/QuestionView.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import API_BASE from "../config/api";

const QuestionEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    softwareId: "",
    standardId: "",
    paperId: "",   // ADD THIS
    subjectId: "",
    topicId: "",
    subtopicId: "",
    level: "",
    mark: "",
    question: "",
    options: ["", "", "", ""],
    correctAnswer: "A",
    explanation: "",

    paragraphId: null,
    paragraphText: "",
    tagline: ""
  });

  const [dropdowns, setDropdowns] = useState({
    softwares: [],
    standards: [],
    subjects: [],
    topics: [],
    subtopics: []
  });

  const [images, setImages] = useState({
    questionImage: null,
    optionAImage: null,
    optionBImage: null,
    optionCImage: null,
    optionDImage: null,
    explanationImage: null
  });

  const baseUrl = `${API_BASE}`;

  /* ---------------- GET QUESTION ---------------- */
  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await axios.get(`${baseUrl}/api/questions/${id}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
          }
        });

        const q = res.data;
        console.log(res.data, 'data')
        // Load dependent dropdowns first
        await loadSubjects(q.standardId);
        await loadTopics(q.subjectId);
        await loadSubtopics(q.subjectId, q.topic);

        // THEN set form data
        setFormData({
          softwareId: q.softwareId,
          paperId: q.paperId,
          standardId: q.standardId,
          subjectId: q.subjectId,

          topicId: q.topicId,
          subtopicId: q.subtopicId,

          level: q.difficultyLevel || "",
          mark: q.mark || "",
          question: q.questionText,

          options: [q.optionA, q.optionB, q.optionC, q.optionD],
          correctAnswer: q.correctAnswer,

          explanation: q.explanation || "",

          paragraphId: q.paragraphId || null,
          paragraphText: q.paragraphText || "",
          tagline: q.tagline || ""
        });

        setImages({
          questionImage: q.questionImageUrl,
          optionAImage: q.optionAImageUrl,
          optionBImage: q.optionBImageUrl,
          optionCImage: q.optionCImageUrl,
          optionDImage: q.optionDImageUrl,
          explanationImage: q.explanationImageUrl
        });

      } catch {
        alert("Failed to load question");
      }
    };

    loadData();
  }, [id]);

  const handleFileChange = (field, file) => {
    setImages(prev => ({
      ...prev,
      [field]: file
    }));
  };

  /* ---------------- DROPDOWNS ---------------- */

  useEffect(() => {
    axios.get(`${baseUrl}/api/questions/softwares`, {

      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
      }
    })
      .then(r => setDropdowns(d => ({ ...d, softwares: r.data })));

    axios.get(`${baseUrl}/api/questions/standards`, {

      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
      }
    })
      .then(r => setDropdowns(d => ({ ...d, standards: r.data })));
  }, []);

  const loadSubjects = async (standardId) => {
    const r = await axios.get(`${baseUrl}/api/questions/subjects/${standardId}`, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` }
    });

    setDropdowns(d => ({ ...d, subjects: r.data }));
  };

  const loadTopics = async (subjectId) => {
    const r = await axios.get(`${baseUrl}/api/questions/topics/${subjectId}`, {

      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
      }
    })
    setDropdowns(d => ({ ...d, topics: r.data }));
  };

  const loadSubtopics = async (topicId) => {
    const r = await axios.get(
      `${baseUrl}/api/questions/subtopics/${topicId}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      }
    );

    setDropdowns(d => ({ ...d, subtopics: r.data }));
  };

  /* ---------------- HANDLERS ---------------- */

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));

    if (field === "standardId") loadSubjects(value);
    if (field === "subjectId") loadTopics(value);
    if (field === "topicId") loadSubtopics(value);
  };

  const handleOptionChange = (index, value) => {
    const updated = [...formData.options];
    updated[index] = value;
    setFormData(prev => ({ ...prev, options: updated }));
  };

  /* ---------------- UPDATE ---------------- */

  const handleSave = async () => {
    if (!["A", "B", "C", "D"].includes(formData.correctAnswer)) {
      alert("Correct answer must be A, B, C or D");
      return;
    }

    const fd = new FormData();

    fd.append("SoftwareId", formData.softwareId);
    fd.append("PaperId", formData.paperId);   // IMPORTANT
    fd.append("SubjectId", formData.subjectId);

    fd.append("TopicId", formData.topicId);
    fd.append("SubTopicId", formData.subtopicId);

    fd.append("QuestionText", formData.question);

    fd.append("OptionA", formData.options[0]);
    fd.append("OptionB", formData.options[1]);
    fd.append("OptionC", formData.options[2]);
    fd.append("OptionD", formData.options[3]);

    fd.append("CorrectAnswer", formData.correctAnswer);
    fd.append("DifficultyLevel", formData.level);
    fd.append("Explanation", formData.explanation);
    fd.append("Mark", formData.mark);

    if (images.questionImage instanceof File)
      fd.append("QuestionImage", images.questionImage);

    if (images.optionAImage instanceof File)
      fd.append("OptionAImage", images.optionAImage);

    if (images.optionBImage instanceof File)
      fd.append("OptionBImage", images.optionBImage);

    if (images.optionCImage instanceof File)
      fd.append("OptionCImage", images.optionCImage);

    if (images.optionDImage instanceof File)
      fd.append("OptionDImage", images.optionDImage);

    if (images.explanationImage instanceof File)
      fd.append("ExplanationImage", images.explanationImage);

    try {
      await axios.put(`${baseUrl}/api/questions/${id}`, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      });

      alert("Updated successfully");
      navigate("/dashboard/quemanagment");
    } catch {
      alert("Update failed");
      // console.log(err.response.data);
    }
  };

  /* ---------------- UI ---------------- */

  return (
    <div className="question-view-wrapper">

      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          प्रश्न संच &gt;&gt; <span>प्रश्न संपादन करा</span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>

          <button className="btn primaryy" onClick={handleSave}>
            सेव्ह करा
          </button>
        </div>
      </div>

      <div className="filter-bar">

        <select className="filter"
          value={formData.softwareId}
          onChange={e => handleChange("softwareId", Number(e.target.value))}
        >
          {dropdowns.softwares.map(s =>
            <option key={s.id} value={s.id}>{s.softwareName}</option>
          )}
        </select>

        <select className="filter"
          value={formData.standardId}
          onChange={e => handleChange("standardId", Number(e.target.value))}
        >
          {dropdowns.standards.map(s =>
            <option key={s.id} value={s.id}>{s.name}</option>
          )}
        </select>

        <select className="filter"
          value={formData.subjectId}
          onChange={e => handleChange("subjectId", Number(e.target.value))}
        >
          {dropdowns.subjects.map(s =>
            <option key={s.id} value={s.id}>{s.name}</option>
          )}
        </select>

      </div>

      <h4>प्रश्न तपशील</h4>

      <div className="filter-bar">

        <select
          value={formData.topicId}
          onChange={e => handleChange("topicId", Number(e.target.value))}
        >
          <option value="">घटक निवडा</option>

          {dropdowns.topics.map(t => (
            <option key={t.topicId} value={t.topicId}>
              {t.name}
            </option>
          ))}
        </select>

        <select
          value={formData.subtopicId}
          onChange={e => handleChange("subtopicId", Number(e.target.value))}
        >
          {dropdowns.subtopics.map(s => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>

        <select className="filter"
          value={formData.level}
          onChange={e => handleChange("level", e.target.value)}
        >
          <option>सोपे</option>
          <option>मध्यम</option>
          <option>कठीण</option>
        </select>

      </div>

      <div className="content-area">
        <div className="left-panel">

          <label>गुण</label>
          <input type="number"
            value={formData.mark}
            onChange={e => handleChange("mark", e.target.value)}
          />

          {formData.paragraphId && (
            <>
              <label>टॅगलाइन</label>
              <input
                value={formData.tagline}
                onChange={e => handleChange("tagline", e.target.value)}
              />

              <label>पॅराग्राफ</label>
              <textarea
                value={formData.paragraphText}
                onChange={e => handleChange("paragraphText", e.target.value)}
              />
            </>
          )}

          <label>प्रश्न</label>
          <input type="text"
            value={formData.question}
            onChange={e => handleChange("question", e.target.value)}
          />

          <label>प्रश्न प्रतिमा</label>

          {images.questionImage && (
            <img
              src={
                typeof images.questionImage === "string"
                  ? baseUrl + images.questionImage
                  : URL.createObjectURL(images.questionImage)
              }
              width="120"
            />
          )}

          <input
            type="file"
            onChange={e => handleFileChange("questionImage", e.target.files[0])}
          />

          {formData.options.map((opt, index) => (
            <div key={index}>
              <label>{`पर्याय ०${index + 1}`}</label>
              <input
                type="text"
                value={opt}
                onChange={e => handleOptionChange(index, e.target.value)}
              />

              {images[`option${String.fromCharCode(65 + index)}Image`] && (
                <img
                  src={
                    typeof images[`option${String.fromCharCode(65 + index)}Image`] === "string"
                      ? baseUrl + images[`option${String.fromCharCode(65 + index)}Image`]
                      : URL.createObjectURL(images[`option${String.fromCharCode(65 + index)}Image`])
                  }
                  width="100"
                />
              )}

              <input
                type="file"
                onChange={e =>
                  handleFileChange(
                    `option${String.fromCharCode(65 + index)}Image`,
                    e.target.files[0]
                  )
                }
              />
            </div>
          ))}

          <label>बरोबर उत्तर</label>
          <select className="correct-answer"
            value={formData.correctAnswer}
            onChange={e => handleChange("correctAnswer", e.target.value)}
          >
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="D">D</option>
          </select>

          <label>स्पष्टीकरण</label>
          <input
            type="text"
            value={formData.explanation}
            onChange={e => handleChange("explanation", e.target.value)}
          />

          <label>स्पष्टीकरण प्रतिमा</label>

          {images.explanationImage && (
            <img
              src={
                typeof images.explanationImage === "string"
                  ? baseUrl + images.explanationImage
                  : URL.createObjectURL(images.explanationImage)
              }
              width="120"
            />
          )}

          <input
            type="file"
            onChange={e => handleFileChange("explanationImage", e.target.files[0])}
          />

        </div>
      </div>

    </div>
  );
};

export default QuestionEdit;
